import { render, staticRenderFns } from "./fraudRules.vue?vue&type=template&id=6be9b9a8&"
import script from "./fraudRules.vue?vue&type=script&lang=js&"
export * from "./fraudRules.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports